let locationOrigin = ''

if (window) {
  locationOrigin = window.location.origin
}

/**
 *   "env" -> environment type

 "is_toning_enabled"               -> is toning API is enabled
 "toning_url"                      -> toning API url
 "api_url"                         ->  app API url
 "resources_base_url"              -> where resources are loaded icons and default css/js
 "asserts":{                       -> assert related configs
 "toning_css_injection"            -> use toning css or not
 "demo_assets"                     -> use demo assert or not
 }
 *
 * @type {{development: {is_toning_enabled: boolean, is_SPA: boolean, feature_updates_url: string, food_diary_api_url: string, api_url: string, api_v2_url: string, braze_sdk_endpoint: string, plugin_files_url: string, toning_url: string, resources_base_url: string, asserts: {toning_css_injection: boolean, demo_assets: boolean}, chat_api_url: string, chat_app_id: string, skipUrlReload: boolean, email_system_api_url: string, habits_tracker_api_url: string, period_tracker_api_url: string, macroactivist_api_url: string, braze_api_key: string}, production: {is_toning_enabled: boolean, is_SPA: boolean, feature_updates_url: string, food_diary_api_url: string, api_url: string, api_v2_url: string, braze_sdk_endpoint: string, toning_url: string, resources_base_url: string, plugin_files_url: string, asserts: {toning_css_injection: boolean, demo_assets: boolean}, chat_api_url: string, chat_app_id: string, skipUrlReload: boolean, email_system_api_url: string, habits_tracker_api_url: string, period_tracker_api_url: string, macroactivist_api_url: string, braze_api_key: string}, env: string, 'production-c': {is_toning_enabled: boolean, is_SPA: boolean, feature_updates_url: string, food_diary_api_url: string, api_url: string, api_v2_url: string, toning_url: string, resources_base_url: string, plugin_files_url: string, asserts: {toning_css_injection: boolean, demo_assets: boolean}, chat_api_url: string, chat_app_id: string, skipUrlReload: boolean, email_system_api_url: string, habits_tracker_api_url: string, period_tracker_api_url: string, macroactivist_api_url: string}, 'toning-preview': {asserts: {toning_css_injection: boolean, demo_assets: boolean}, is_toning_enabled: boolean, feature_updates_url: string, skipUrlReload: boolean, api_url: string, email_system_api_url: string, toning_url: string, resources_base_url: string}, demo: {asserts: {toning_css_injection: boolean, demo_assets: boolean}, is_toning_enabled: boolean, feature_updates_url: string, skipUrlReload: boolean, api_url: string, email_system_api_url: string, toning_url: string, resources_base_url: string}, staging: {asserts: {toning_css_injection: boolean, demo_assets: boolean}, is_toning_enabled: boolean, feature_updates_url: string, skipUrlReload: boolean, api_url: string, email_system_api_url: string, toning_url: string, resources_base_url: string}}}
 */
let customConfig = {
  'env': 'production',
  'production': { // prod  global
    "member_progress_api_url_v1": 'https://api.macroactive.com/',
    "member_progress_api_url": 'https://api.macroactive.com/',
    'is_toning_enabled': false,
    'is_SPA': true,
    'toning_url': 'https://toning.macroactive.com/api/',
    'api_url': locationOrigin + '/api/',
    'api_v2_url': locationOrigin + '/v2/',
    'food_diary_api_url': 'https://d38v59tzc6zi5x.cloudfront.net/api/',
    'period_tracker_api_url': 'https://royal-frost-dj4f9ryq93pr.vapor-farm-e1.com/api/v1/',
    'habits_tracker_api_url': 'https://api.macroactive.com/habit-tracker/2024-02-07/',
    'macroactivist_api_url': 'https://macroactivists-api.macroactivemvp.com/api/v1/',
    'resources_base_url': 'https://d39bs4ovl1ajzi.cloudfront.net/14606',
    'feature_updates_url': 'https://releases.macroactive.com/?get-feature-highlights=true',
    'chat_api_url': 'https://coachin-api.macroactivemvp.com/api/v1/',
    'plugin_files_url': 'https://de7afc2hc76x7.cloudfront.net/',
    'email_system_api_url': 'https://crimson-cloud-qhkhuud8roib.vapor-farm-d1.com/api/',
    'chat_app_id': '8uVYAW2C',
    'community_api_url': 'https://api.macroactive.com/community/2023-08-02/',
    'community_asset_url': 'https://de7afc2hc76x7.cloudfront.net/community/11400/assets/',
    'chat_asset_url': 'https://app-redesign-plugin-files.s3.us-west-1.amazonaws.com/nalf-chat/10300/assets/',
    'step_tracker_api_url': 'https://api.macroactive.com/wearable/2024-07-03/',

    'skipUrlReload': true,
    'asserts': {
      'toning_css_injection': true,
      'demo_assets': false,
    }
  },
  'toning-preview':{
    "is_toning_enabled":false,
    "toning_url": "https://toning.macroactivemvp.com/api/",
    "community_api_url" : "https://platform-mock-api.macroactivemvp.com/api/community/2023-08-02/",
    "community_asset_url" : "https://app-redesign-plugin-files.s3.us-west-1.amazonaws.com/previews/prod/community/assets/",
    "api_url": "https://platform-mock-api.macroactivemvp.com/api/",
    "resources_base_url": window.location.origin,
    "asserts":{
      "toning_css_injection" :false,
      "demo_assets" :true,
    }
  },
  'development': {
    'is_toning_enabled': false,
    'is_SPA': true,
    "feedBackAPIURL": "https://test-customer-feedback.macroactivemvp.com/api/v1/feedback",
    'habits_tracker_api_url': 'https://api-dev.macroactive.com/habit-tracker/2024-02-07/',
    'chat_api_url': 'https://coachin-api-qa.macroactivemvp.com/api/v1/',
    'food_diary_api_url': 'https://staging-food-diary.macroactivemvp.com/api/',
    'plugin_files_url': 'https://de7afc2hc76x7.cloudfront.net/',
    'macroactivist_api_url': 'https://macroactivists-api-qa.macroactivemvp.com/api/v1/',
    // "period_tracker_api_url": 'https://royal-frost-dj4f9ryq93pr.vapor-farm-e1.com/api/v1/',
    // 'period_tracker_api_url': 'https://stunning-morning-fg8g4bbdlj1t.vapor-farm-e1.com/api/v1/',
    'period_tracker_api_url': 'https://period-tracker-staging.macroactivemvp.com/api/v1/',
    'toning_url': 'https://test-toning.macroactivemvp.com/api/',
    "member_progress_api_url_v1": 'https://api-dev.macroactive.com/',
    "member_progress_api_url": 'https://api-dev.macroactive.com/',
    'community_api_url': 'https://api-dev.macroactive.com/community/2023-08-02/',
    // 'api_v2_url': 'https://idp-customer.alpha-macropt.com/v2/',  // idp
    // 'api_url': 'https://idp-customer.alpha-macropt.com/api/', // idp
    'api_url': 'https://bkx1xb2um4.execute-api.us-west-1.amazonaws.com/api/',  //alpha
    'api_v2_url': 'https://bkx1xb2um4.execute-api.us-west-1.amazonaws.com/v2/',
    //'community_asset_url': 'http://127.0.0.1:8081/assets/',

    // 'api_v2_url': 'https://platform-mock-api.macroactivemvp.com/v2/',
    // 'api_url': 'https://platform-mock-api.macroactivemvp.com/api/', // mock

    // "api_v2_url": 'https://k5763ndh3h.execute-api.us-west-1.amazonaws.com/v2/',
    // "api_url": 'https://k5763ndh3h.execute-api.us-west-1.amazonaws.com/api/',
    // 'api_v2_url': 'https://nl-alpha-customer.alpha-macro.com/v2/',
    // 'api_url': 'https://nl-alpha-customer.alpha-macro.com/api/',  //alpha

    // 'api_url': 'https://k5763ndh3h.execute-api.us-west-1.amazonaws.com/api/',  //beta
    // "api_url":   'https://f5b7bchq8c.execute-api.us-west-1.amazonaws.com/api/', //arabic
    'feature_updates_url': 'https://releases.macroactive.com/?get-feature-highlights=true',
    'email_system_api_url': 'https://jubilant-silence-zcfetwxgupn3.vapor-farm-d1.com/api/',
    'resources_base_url': '',
    'skipUrlReload': true,
    'asserts': {
      'toning_css_injection': false,
      'demo_assets': false,
    }
  },
  'production-c': { // caroline
    "member_progress_api_url_v1": 'https://api.macroactive.com/',
    "member_progress_api_url": 'https://api.macroactive.com/',
    'is_toning_enabled': false,
    'is_SPA': true,
    'toning_url': 'https://toning.macroactive.com/api/',
    'api_url': locationOrigin + '/api/',
    'api_v2_url': locationOrigin + '/v2/',
    'habits_tracker_api_url': 'https://api.macroactive.com/habit-tracker/2024-02-07/',
    'food_diary_api_url': 'https://food-diary.macroactivemvp.com/api/',
    'period_tracker_api_url': 'https://royal-frost-dj4f9ryq93pr.vapor-farm-e1.com/api/v1/', // TODO : check
    'macroactivist_api_url': 'https://macroactivists-api.macroactivemvp.com/api/v1/', // TODO : check
    'resources_base_url': 'https://d39bs4ovl1ajzi.cloudfront.net/theme-caroline/13301', // TODO : check
    'feature_updates_url': 'https://releases.macroactive.com/?get-feature-highlights=true',
    'email_system_api_url': 'https://crimson-cloud-qhkhuud8roib.vapor-farm-d1.com/api/',
    'chat_api_url': 'https://coachin-api.macroactivemvp.com/api/v1/',
    'plugin_files_url': 'https://de7afc2hc76x7.cloudfront.net/',
    'community_api_url': 'https://api.macroactive.com/community/2023-08-02/',
    'community_asset_url': 'https://de7afc2hc76x7.cloudfront.net/theme-2/community/10400/assets/',
    'chat_asset_url': 'https://app-redesign-plugin-files.s3.us-west-1.amazonaws.com/theme-2/nalf-chat/latest/assets/',
    'chat_app_id': '8uVYAW2C',
    'skipUrlReload': true,
    'asserts': {
      'toning_css_injection': true,  // TODO : caroline
      'demo_assets': false, // TODO : caroline
    }
  },
}
export default customConfig[customConfig['env']]
export const env = customConfig['env']
